import ENDictionary from './news-en-dictionary'
import PTDictionary from './news-pt-dictionary'


const Dictionary = {
    PT: PTDictionary,
    EN: ENDictionary,
}

export default Dictionary;